import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { formsCalcPropsChange, formsCalcDataChange, CalcValidateChange } from '../stores/propertySlice'
import { toThousandSeparated, VaridateCalcDataField, getAmount } from './ValidateHelper'
import * as formulajs from '@formulajs/formulajs'

export function CalculatorsV2(props) {
  const dispatch = useDispatch();

  const [isEditMode, setIsEditMode] = useState(false);
  
  useEffect(() => {
    console.log('#### useEffect CalculatorsV2');

    if(props.calculatorHomeLoanSetting.value === 0
        || props.calculatorLandSetting.value === 0
        || props.calculatorSMESetting.value === 0
    ){
        return;
    }

    var calHomeLoanSetting = props.calculatorHomeLoanSetting.value;
    var calLandSetting = props.calculatorLandSetting.value;
    var calSMESetting = props.calculatorSMESetting.value;

    var stayTotalInstallmentPerMonth;
    var stayTotalLimitAmount;
    var stayInstallmentYear;
    var stayPropertyLimitAmount;
    var stayPropertyInstallmentPerMonth;
    var stayDecorationLimitAmount;
    var stayDecorationInstallmentPerMonth;
    var stayIncomePerMonth;
    var stayDebtBurdenPerMonth;
    var stayCanTakeDecoration;

    if (props.appliedCalcTypes.value.forStay === props.calcTypes.Home) {
        var defaultLoanYear = +calHomeLoanSetting.DefaultLoanYear;

        var result = calHomeLoan({
            B2_propertyPrice: props.definedPropertyPrice.value,
            B3_homeLoanType: calHomeLoanSetting.B3HomeLoanType,
            B5_propertyLoanAmount: props.definedPropertyPrice.value,
            B6_career: calHomeLoanSetting.B6Career,
            B7_age: +calHomeLoanSetting.B7Age,
            B9_propertyLoanYear: defaultLoanYear,
            B10_salary: '',
            B11_deptBurdenPerMonth: '',
            B12_appraisalPrice: props.appraisalPrice.value,
            B20_decorationLoanAmount: null,
            B21_decorationLoanYear: defaultLoanYear,
            calHomeLoanSetting: calHomeLoanSetting,
        });

        console.log('cal home loan result:', result);

        stayCanTakeDecoration = props.definedPropertyPrice.value <= 10000000; //true;

        stayTotalInstallmentPerMonth = forceNumber(result.B29_HLInstallmentPerMonth) + (stayCanTakeDecoration ? forceNumber(result.B34_HDInstallmentPerMonth) : 0);
        stayTotalLimitAmount = forceNumber(result.B28_HLLimit) + (stayCanTakeDecoration ? forceNumber(result.B33_HDLimit) : 0);
        stayPropertyLimitAmount = forceNumber(result.B28_HLLimit);
        stayDecorationLimitAmount = forceNumber(+result.B33_HDLimit);

        stayInstallmentYear = forceNumber(result.B8_maxLoanYear);
        stayPropertyInstallmentPerMonth = forceNumber(result.B29_HLInstallmentPerMonth);
        stayDecorationInstallmentPerMonth = forceNumber(+result.B34_HDInstallmentPerMonth);

        dispatch(formsCalcDataChange({ 
            field: "stayTotalInstallmentPerMonth", 
            value: toThousandSeparated('' + stayTotalInstallmentPerMonth.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayTotalLimitAmount", 
            value: toThousandSeparated('' + stayTotalLimitAmount.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayInstallmentYear", 
            value: toThousandSeparated('' + stayInstallmentYear.toFixed(0)), 
            maxValue: result.B8_maxLoanYear,
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayPropertyLimitAmount", 
            value: toThousandSeparated('' + stayPropertyLimitAmount.toFixed(0)),
            maxValue: +stayPropertyLimitAmount.toFixed(0),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayPropertyInstallmentPerMonth", 
            value: toThousandSeparated('' + stayPropertyInstallmentPerMonth.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayDecorationLimitAmount", 
            value: toThousandSeparated('' + stayDecorationLimitAmount.toFixed(0)), 
            maxValue: +stayDecorationLimitAmount.toFixed(0),
            //visible: stayCanTakeDecoration,
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayDecorationInstallmentPerMonth", 
            value: toThousandSeparated('' + stayDecorationInstallmentPerMonth.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayIncomePerMonth", 
            value: '0',
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayDebtBurdenPerMonth", 
            value: '0',
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayCanTakeDecoration", 
            value: stayCanTakeDecoration,
        }));
    } else if (props.appliedCalcTypes.value.forStay === props.calcTypes.Land) {
        var defaultLoanYear = +calLandSetting.DefaultLoanYear;

        var result = calLand({
            B2_propertyPrice: props.definedPropertyPrice.value,
            B3_homeLoanType: calLandSetting.B3HomeLoanType,
            B5_propertyLoanAmount: props.definedPropertyPrice.value,
            B6_career: calLandSetting.B6Career,
            B7_age: +calLandSetting.B7Age,
            B9_propertyLoanYear: defaultLoanYear,
            B10_salary: '',
            B11_deptBurdenPerMonth: '',
            B12_appraisalPrice: props.appraisalPrice.value,
            calLandSetting: calLandSetting,
        });

        console.log('cal land result:', result);

        stayTotalInstallmentPerMonth = forceNumber(result.B19_HLInstallmentPerMonth);
        stayTotalLimitAmount = forceNumber(result.B18_HLLimit);
        stayPropertyLimitAmount = forceNumber(result.B18_HLLimit);

        stayInstallmentYear = forceNumber(result.B8_maxLoanYear);
        stayPropertyInstallmentPerMonth = forceNumber(result.B19_HLInstallmentPerMonth);
        stayCanTakeDecoration = false;

        dispatch(formsCalcDataChange({ 
            field: "stayTotalInstallmentPerMonth", 
            value: toThousandSeparated('' + stayTotalInstallmentPerMonth.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayTotalLimitAmount", 
            value: toThousandSeparated('' + stayTotalLimitAmount.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayInstallmentYear", 
            value: toThousandSeparated('' + stayInstallmentYear.toFixed(0)), 
            maxValue: result.B8_maxLoanYear,
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayPropertyLimitAmount", 
            value: toThousandSeparated('' + stayPropertyLimitAmount.toFixed(0)),
            maxValue: +stayPropertyLimitAmount.toFixed(0),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayPropertyInstallmentPerMonth", 
            value: toThousandSeparated('' + stayPropertyInstallmentPerMonth.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayIncomePerMonth", 
            value: '0',
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayDebtBurdenPerMonth", 
            value: '0',
        }));
        dispatch(formsCalcDataChange({ 
            field: "stayCanTakeDecoration", 
            value: stayCanTakeDecoration,
        }));
    }

    var decoration = props.propertyTypeID.value !== '01';
    var smePropertyType = (["02", "03", "04", "05"].indexOf(props.propertyTypeID.value) !== -1) ? props.propertyTypeID.value : 'other';

    dispatch(formsCalcDataChange({ 
        field: "smePropertyType", 
        value: smePropertyType,
    }));

    var smeDefaultLoanYear = +((smePropertyType === "other") ? calSMESetting.DefaultOtherLoanYear : calSMESetting.DefaultBuildingLoanYear);

    var resultSME = calSME({
        D10_propertyPrice: props.definedPropertyPrice.value,
        D12_propertyLoanAmount: props.definedPropertyPrice.value,
        D18_propertyType: smePropertyType,
        D20_appraisalPrice: props.appraisalPrice.value,
        D28_propertyLoanYear: smeDefaultLoanYear,
        D30_profitPerMonth: '',
        D32_deptBurdenPerMonth: '',
        D37_decorationLoanAmount: decoration ? null : 0,
        calSMESetting: calSMESetting,
    });

    console.log('cal SME result:', resultSME);

    var businessTotalInstallmentPerMonth = forcePositiveNumber(resultSME.D46_propertyInstallmentPerMonth) + forcePositiveNumber(resultSME.D50_decorationInstallmentPerMonth);
    var businessTotalLimitAmount = forcePositiveNumber(resultSME.D44_propertyPrimaryMaxLoanAmount) + forcePositiveNumber(resultSME.D48_decorationPrimaryMaxLoanAmount);
    var businessInstallmentYear = forcePositiveNumber(resultSME.D56_loanableYear);
    var businessPropertyLimitAmount = forcePositiveNumber(resultSME.D44_propertyPrimaryMaxLoanAmount);
    var businessPropertyInstallmentPerMonth = forcePositiveNumber(resultSME.D46_propertyInstallmentPerMonth);
    var businessDecorationLimitAmount = forcePositiveNumber(resultSME.D48_decorationPrimaryMaxLoanAmount);
    var businessDecorationInstallmentPerMonth = forcePositiveNumber(resultSME.D50_decorationInstallmentPerMonth);

    dispatch(formsCalcDataChange({ 
        field: "businessTotalInstallmentPerMonth", 
        value: toThousandSeparated('' + businessTotalInstallmentPerMonth.toFixed(0)),
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessTotalLimitAmount", 
        value: toThousandSeparated('' + businessTotalLimitAmount.toFixed(0)),
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessInstallmentYear", 
        value: toThousandSeparated('' + businessInstallmentYear.toFixed(0)), 
        maxValue: resultSME.I30_maxLoanYear, //+businessInstallmentYear.toFixed(0),
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessPropertyLimitAmount", 
        value: toThousandSeparated('' + businessPropertyLimitAmount.toFixed(0)),
        maxValue: +businessPropertyLimitAmount.toFixed(0),
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessPropertyInstallmentPerMonth", 
        value: toThousandSeparated('' + businessPropertyInstallmentPerMonth.toFixed(0)),
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessDecorationLimitAmount", 
        value: toThousandSeparated('' + businessDecorationLimitAmount.toFixed(0)), 
        maxValue: +businessDecorationLimitAmount.toFixed(0),
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessDecorationInstallmentPerMonth", 
        value: toThousandSeparated('' + businessDecorationInstallmentPerMonth.toFixed(0)),
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessIncomePerMonth", 
        value: '0',
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessDebtBurdenPerMonth", 
        value: '0',
    }));

    dispatch(formsCalcDataChange({ 
        field: "decoration", 
        value: decoration,
    }));
    dispatch(formsCalcDataChange({ 
        field: "stayValidateFields", 
        value: getValidateField('stay', decoration && stayCanTakeDecoration),
    }));
    dispatch(formsCalcDataChange({ 
        field: "businessValidateFields", 
        value: getValidateField('business', decoration),
    }));
    // dispatch(formsCalcDataChange({ 
    //     field: "stayCanTakeDecoration", 
    //     value: stayCanTakeDecoration,
    // }));
  }, [props.appliedCalcTypes.value]);

  function forcePositiveNumber(num, defaultValue) {
    var result = forceNumber(num, defaultValue);

    if(result < 0){
        return 0;
    }

    return result;
  }

  function forceNumber(num, defaultValue) {
    if (defaultValue === undefined) {
        defaultValue = 0;
    }

    if (typeof num !== 'number') {
        return defaultValue;
    }

    if (isNaN(num)) {
        return defaultValue;
    }

    return num;
  }

  function formsDataChange(tab, field, e) {
    console.log('change ' + field + ' = ' + e.target.value);

    let value = e.target.value;
    let numValue = parseFloat(value.replace(/,/g, ''));
    //const limit = 1000000000;
    //numValue = numValue > limit ? limit : numValue;

    // let maxValue = props[field].maxValue;

    // if (maxValue !== undefined) {
    //     numValue = numValue > maxValue ? maxValue : numValue;
    // }

    if (numValue || numValue === 0) {
        //value = numValue.toLocaleString();

        let numStr = '' + numValue;

        if (props[field].maxDigit) {
            numStr = numStr.slice(0, props[field].maxDigit);
        }
        
        value = toThousandSeparated('' + numStr);
    } else {
        value = '';
    }

    dispatch(formsCalcDataChange({ 
        field: field, 
        value: value,
        //errorMessage: VaridateCalcDataField(props, field, value),
    }));

    //recalculate(tab, field, value);
  }

  function formsBlur(tab, field, e) {
    console.log('blur ' + field);

    e.preventDefault();

    dispatch(CalcValidateChange({ 
        field: field,
        errorMessage: VaridateCalcDataField(props, field, e.target.value),
    }));

    recalculate(tab, field, e.target.value);
  }

  function recalculate(tab, field, newValue) {
    var calFormData = {
        stayInstallmentYear: props.stayInstallmentYear.value,
        stayPropertyLimitAmount: props.stayPropertyLimitAmount.value,
        stayDecorationLimitAmount: props.stayDecorationLimitAmount.value,
        stayIncomePerMonth: props.stayIncomePerMonth.value,
        stayDebtBurdenPerMonth: props.stayDebtBurdenPerMonth.value,

        businessInstallmentYear: props.businessInstallmentYear.value,
        businessPropertyLimitAmount: props.businessPropertyLimitAmount.value,
        businessDecorationLimitAmount: props.businessDecorationLimitAmount.value,
        businessIncomePerMonth: props.businessIncomePerMonth.value,
        businessDebtBurdenPerMonth: props.businessDebtBurdenPerMonth.value,
    };

    calFormData[field] = newValue;

    var calHomeLoanSetting = props.calculatorHomeLoanSetting.value;
    var calLandSetting = props.calculatorLandSetting.value;
    var calSMESetting = props.calculatorSMESetting.value;
    
    if (tab === 'stay') {
        var stayInstallmentYear = Math.min(+getAmount(calFormData.stayInstallmentYear), props.stayInstallmentYear.maxValue);
 
        if (field === 'stayInstallmentYear') {
            if (calFormData.stayInstallmentYear !== '' && +getAmount(calFormData.stayInstallmentYear) > props.stayInstallmentYear.maxValue) {
                dispatch(formsCalcDataChange({ 
                    field: "stayInstallmentYear", 
                    value: toThousandSeparated('' + stayInstallmentYear.toFixed(0)),
                    note: 'ระยะเวลาผ่อนชำระสูงสุด ' + props.stayInstallmentYear.maxValue + ' ปี',
                }));
            } else {
                dispatch(formsCalcDataChange({ 
                    field: "stayInstallmentYear",
                    note: "",
                }));
            }
        }

        if(!validateCalcForm(tab, calFormData)){
            console.log('validate calc form failed!');

            dispatch(formsCalcDataChange({ 
                field: "stayTotalInstallmentPerMonth", 
                value: "0",
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayTotalLimitAmount", 
                value: "0",
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayPropertyInstallmentPerMonth", 
                value: "0",
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayDecorationInstallmentPerMonth", 
                value: "0",
            }));

            return;
        }

        var stayTotalInstallmentPerMonth;
        var stayTotalLimitAmount;
        var stayPropertyLimitAmount;
        var stayDecorationLimitAmount = 0;
        //var canTakeOnDecorationLoan;
        var stayCanTakeDecoration;
        var stayPropertyInstallmentPerMonth;
        var stayDecorationInstallmentPerMonth;

        if (props.appliedCalcTypes.value.forStay === props.calcTypes.Home) {
            //cal home loan
            var result = calHomeLoan({
                B2_propertyPrice: props.definedPropertyPrice.value,
                B3_homeLoanType: calHomeLoanSetting.B3HomeLoanType,
                B5_propertyLoanAmount: +getAmount(calFormData.stayPropertyLimitAmount),
                B6_career: calHomeLoanSetting.B6Career,
                B7_age: +calHomeLoanSetting.B7Age,
                B9_propertyLoanYear: stayInstallmentYear,
                B10_salary: +getAmount(calFormData.stayIncomePerMonth),
                B11_deptBurdenPerMonth: +getAmount(calFormData.stayDebtBurdenPerMonth),
                B12_appraisalPrice: props.appraisalPrice.value,
                B20_decorationLoanAmount: +getAmount(calFormData.stayDecorationLimitAmount),
                B21_decorationLoanYear: stayInstallmentYear,
                calHomeLoanSetting: calHomeLoanSetting,
            });
    
            console.log('cal home loan result:', result);

            if(checkCalError(result, "LackOfPayDeptAbility")) {
                console.log('cal home loan: LackOfPayDeptAbility');

                stayTotalInstallmentPerMonth = 0;
                stayTotalLimitAmount = 0;
                stayPropertyLimitAmount = 0;
                stayDecorationLimitAmount = 0;
                stayPropertyInstallmentPerMonth = 0;
                stayDecorationInstallmentPerMonth = 0;

                showCalErrorPopup('ไม่ผ่านความสามารถการชำระหนี้');
            } else {
                stayTotalInstallmentPerMonth = forceNumber(result.B16_HLInstallmentPerMonth) + forceNumber(result.B26_HDInstallmentPerMonth);
                stayTotalLimitAmount = forceNumber(result.B14_HLPrimaryMaxLimit) + forceNumber(result.B24_HDPrimaryMaxLimit);
                stayPropertyLimitAmount = forceNumber(result.B14_HLPrimaryMaxLimit);
                stayDecorationLimitAmount = forceNumber(+result.B24_HDPrimaryMaxLimit);
                //canTakeOnDecorationLoan = result.B19_canTakeOnDecorationLoan;
                stayCanTakeDecoration = result.B19_canTakeOnDecorationLoan;
                stayPropertyInstallmentPerMonth = forceNumber(result.B16_HLInstallmentPerMonth);
                stayDecorationInstallmentPerMonth = forceNumber(result.B26_HDInstallmentPerMonth);

                dispatch(formsCalcDataChange({ 
                    field: "stayCanTakeDecoration", 
                    value: stayCanTakeDecoration,
                }));

                dispatch(formsCalcDataChange({ 
                    field: "stayValidateFields", 
                    value: getValidateField('stay', props.decoration.value && stayCanTakeDecoration),
                }));
            }
    
            dispatch(formsCalcDataChange({ 
                field: "stayTotalInstallmentPerMonth", 
                value: toThousandSeparated('' + stayTotalInstallmentPerMonth.toFixed(0)),
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayTotalLimitAmount", 
                value: toThousandSeparated('' + stayTotalLimitAmount.toFixed(0)),
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayPropertyLimitAmount", 
                value: toThousandSeparated('' + stayPropertyLimitAmount.toFixed(0)),
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayDecorationLimitAmount", 
                value: toThousandSeparated('' + stayDecorationLimitAmount.toFixed(0)),
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayPropertyInstallmentPerMonth", 
                value: toThousandSeparated('' + stayPropertyInstallmentPerMonth.toFixed(0)),
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayDecorationInstallmentPerMonth", 
                value: toThousandSeparated('' + stayDecorationInstallmentPerMonth.toFixed(0)),
            }));
        } else if (props.appliedCalcTypes.value.forStay === props.calcTypes.Land) {
            //cal land
            var result = calLand({
                B2_propertyPrice: props.definedPropertyPrice.value,
                B3_homeLoanType: calLandSetting.B3HomeLoanType,
                B5_propertyLoanAmount: +getAmount(calFormData.stayPropertyLimitAmount),
                B6_career: calLandSetting.B6Career,
                B7_age: +calLandSetting.B7Age,
                B9_propertyLoanYear: stayInstallmentYear,
                B10_salary: +getAmount(calFormData.stayIncomePerMonth),
                B11_deptBurdenPerMonth: +getAmount(calFormData.stayDebtBurdenPerMonth),
                B12_appraisalPrice: props.appraisalPrice.value,
                calLandSetting: calLandSetting,
            });
    
            console.log('cal land result:', result);

            if(checkCalError(result, "LackOfPayDeptAbility")) {
                console.log('cal land: LackOfPayDeptAbility');

                stayTotalInstallmentPerMonth = 0;
                stayTotalLimitAmount = 0;
                stayPropertyLimitAmount = 0;
                stayPropertyInstallmentPerMonth = 0;

                showCalErrorPopup('ไม่ผ่านความสามารถการชำระหนี้');
            } else {
                stayTotalInstallmentPerMonth = forceNumber(result.B16_installmentPerMonth);
                stayTotalLimitAmount = forceNumber(result.B14_primaryMaxLimit);
                stayPropertyLimitAmount = forceNumber(result.B14_primaryMaxLimit);
                //canTakeOnDecorationLoan = false;
                stayPropertyInstallmentPerMonth = forceNumber(result.B16_installmentPerMonth);
            }
    
            dispatch(formsCalcDataChange({ 
                field: "stayTotalInstallmentPerMonth", 
                value: toThousandSeparated('' + stayTotalInstallmentPerMonth.toFixed(0)),
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayTotalLimitAmount", 
                value: toThousandSeparated('' + stayTotalLimitAmount.toFixed(0)),
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayPropertyLimitAmount", 
                value: toThousandSeparated('' + stayPropertyLimitAmount.toFixed(0)),
            }));
            dispatch(formsCalcDataChange({ 
                field: "stayPropertyInstallmentPerMonth", 
                value: toThousandSeparated('' + stayPropertyInstallmentPerMonth.toFixed(0)),
            }));
        }

        //props.stayDecorationLimitAmount.visible = canTakeOnDecorationLoan;
    } else if (tab === 'business') {
        var businessInstallmentYear = Math.min(+getAmount(calFormData.businessInstallmentYear), props.businessInstallmentYear.maxValue);

        if (field === 'businessInstallmentYear') {
            if (calFormData.businessInstallmentYear !== '' && +getAmount(calFormData.businessInstallmentYear) > props.businessInstallmentYear.maxValue) {
                dispatch(formsCalcDataChange({ 
                    field: "businessInstallmentYear", 
                    value: toThousandSeparated('' + businessInstallmentYear.toFixed(0)),
                    note: 'ระยะเวลาผ่อนชำระสูงสุด ' + props.businessInstallmentYear.maxValue + ' ปี',
                }));
            } else {
                dispatch(formsCalcDataChange({ 
                    field: "businessInstallmentYear",
                    note: "",
                }));
            }
        }

        if(!validateCalcForm(tab, calFormData)){
            console.log('validate calc form failed!');

            dispatch(formsCalcDataChange({ 
                field: "businessTotalInstallmentPerMonth", 
                value: "0",
            }));
            dispatch(formsCalcDataChange({ 
                field: "businessTotalLimitAmount", 
                value: "0",
            }));
            dispatch(formsCalcDataChange({ 
                field: "businessPropertyInstallmentPerMonth", 
                value: "0",
            }));
            dispatch(formsCalcDataChange({ 
                field: "businessDecorationInstallmentPerMonth", 
                value: "0",
            }));

            return;
        }

        var resultSME = calSME({
            D10_propertyPrice: props.definedPropertyPrice.value,
            D12_propertyLoanAmount: Math.min(+getAmount(calFormData.businessPropertyLimitAmount), props.definedPropertyPrice.value),
            D18_propertyType: props.smePropertyType.value,
            D20_appraisalPrice: props.appraisalPrice.value,
            D28_propertyLoanYear: businessInstallmentYear,
            D30_profitPerMonth: +getAmount(calFormData.businessIncomePerMonth),
            D32_deptBurdenPerMonth: +getAmount(calFormData.businessDebtBurdenPerMonth),
            D37_decorationLoanAmount: +getAmount(calFormData.businessDecorationLimitAmount),
            calSMESetting: calSMESetting,
        });
    
        console.log('cal SME result:', resultSME);
    
        var businessTotalInstallmentPerMonth;
        var businessTotalLimitAmount;
        var businessPropertyLimitAmount;
        var businessDecorationLimitAmount;
        var businessPropertyInstallmentPerMonth;
        var businessDecorationInstallmentPerMonth;

        if (resultSME.D53_errorMessage !== "") {
            businessTotalInstallmentPerMonth = 0;
            businessTotalLimitAmount = 0;
            businessPropertyLimitAmount = 0;
            businessDecorationLimitAmount = 0;
            businessPropertyInstallmentPerMonth = 0;
            businessDecorationInstallmentPerMonth = 0;

            showCalErrorPopup('รายได้ที่แจ้งไม่เพียงพอต่อการชำระหนี้');
        } else {
            businessTotalInstallmentPerMonth = forcePositiveNumber(resultSME.D46_propertyInstallmentPerMonth) + forcePositiveNumber(resultSME.D50_decorationInstallmentPerMonth);
            businessTotalLimitAmount = forcePositiveNumber(resultSME.D44_propertyPrimaryMaxLoanAmount) + forcePositiveNumber(resultSME.D48_decorationPrimaryMaxLoanAmount);
            businessPropertyLimitAmount = forcePositiveNumber(resultSME.D44_propertyPrimaryMaxLoanAmount);
            businessDecorationLimitAmount = forcePositiveNumber(resultSME.D48_decorationPrimaryMaxLoanAmount);
            businessPropertyInstallmentPerMonth = forcePositiveNumber(resultSME.D46_propertyInstallmentPerMonth);
            businessDecorationInstallmentPerMonth = forcePositiveNumber(resultSME.D50_decorationInstallmentPerMonth);
        }

        dispatch(formsCalcDataChange({ 
            field: "businessTotalInstallmentPerMonth", 
            value: toThousandSeparated('' + businessTotalInstallmentPerMonth.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "businessTotalLimitAmount", 
            value: toThousandSeparated('' + businessTotalLimitAmount.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "businessPropertyLimitAmount", 
            value: toThousandSeparated('' + businessPropertyLimitAmount.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "businessDecorationLimitAmount", 
            value: toThousandSeparated('' + businessDecorationLimitAmount.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "businessPropertyInstallmentPerMonth", 
            value: toThousandSeparated('' + businessPropertyInstallmentPerMonth.toFixed(0)),
        }));
        dispatch(formsCalcDataChange({ 
            field: "businessDecorationInstallmentPerMonth", 
            value: toThousandSeparated('' + businessDecorationInstallmentPerMonth.toFixed(0)),
        }));
    } else {
        throw new Error('Param "tab" has an invalid value.');
    }
  }

  function showCalErrorPopup(message) {
    props.openErrorPopup(message)
  }

  function checkCalError(calResult, errorCode) {
    return calResult.errors.filter(function(error){
        return error.errorCode === errorCode;
    }).length > 0;
 }

  function validateCalcForm(tab, formData) {
    var validateFields = [];

    if (tab === 'stay') {
        validateFields = props.stayValidateFields.value;

        // dispatch(formsCalcDataChange({ 
        //     field: "stayInstallmentYear",
        //     note: "",
        // }));
    } else if (tab === 'business') {
        validateFields = props.businessValidateFields.value;

        // dispatch(formsCalcDataChange({ 
        //     field: "businessInstallmentYear",
        //     note: "",
        // }));
    }

    const validateResults = validateFields.map(field => {
        var errorMessage = VaridateCalcDataField(props, field, formData[field]);

        dispatch(CalcValidateChange({ 
            field: field,
            errorMessage: errorMessage,
        }));

        return errorMessage === '';
    });

    return validateResults.every(c => c);
  }

  function getValidateField(tab, decoration) {
    let validateField = [];

    if (tab === 'stay') {
        validateField = [
            'stayInstallmentYear',
            'stayPropertyLimitAmount',
            'stayIncomePerMonth',
            'stayDebtBurdenPerMonth',
        ];

        if (decoration) {
            validateField.push('stayDecorationLimitAmount');
        }
    } else if (tab === 'business') {
        validateField = [
            'businessInstallmentYear',
            'businessPropertyLimitAmount',
            'businessIncomePerMonth',
            'businessDebtBurdenPerMonth',
        ];

        if (decoration) {
            validateField.push('businessDecorationLimitAmount');
        }
    }

    return validateField;
  }

  function ErrorMessage(props) {
    return <span className="error-message" style={{ display: props.message ? "block" : "none" }}>{props.message}</span>;
  }

  function Note(props) {
    return <span style={{ display: props.message ? "block" : "none" }}>{props.message}</span>;
  }

  function handleChangeLimitButtonClick() {
    setIsEditMode(true);
  }

  return (
    <section id="calculators" className="calculate-container">
        <div className="container-calculate view-mode" no-decoration={!props.decoration.value ? 'true' : 'false'}>
            <h2 className="title">คำนวณวงเงินกู้สินเชื่อทรัพย์<span style={{ whiteSpace: 'nowrap' }}>มือสองเบื้องต้น</span></h2>
            <div className="wrapper-target">
                <div className="title-target">วัตถุประสงค์การกู้ :</div>
                <ul className="nav nav-tabs wrapper-tab" id="myTab" role="tablist">
                    <li role="presentation" style={{display: props.appliedCalcTypes.value.forStay !== null ? 'list-item' : 'none'}}>
                        <button id="CalForStayButton" className={'nav-link btn-tab ' + (props.appliedCalcTypes.value.forStay !== null ? 'active' : '')} data-bs-toggle="tab" data-bs-target="#for-stay" type="button" role="tab" aria-controls="for-stay" aria-selected="true">
                            <i className="ic-npa ic-npa-icon-house"></i>
                            <span data-kbct="tab_content" data-kblb="home" data-kbgp="loan_for" data-kbsc="calculate" data-kbid={props.propertyId}>เพื่ออยู่อาศัย</span>
                        </button>
                    </li>
                    <li role="presentation">
                        <button id="CalForBusinessButton" className={'nav-link btn-tab ' + (props.appliedCalcTypes.value.forStay !== null ? '' : 'active')} data-bs-toggle="tab" data-bs-target="#for-business" type="button" role="tab" aria-controls="for-business" aria-selected="false">
                            <i className="ic-npa ic-npa-icon-business"></i>
                            <span data-kbct="tab_content" data-kblb="business" data-kbgp="loan_for" data-kbsc="calculate" data-kbid={props.propertyId}>เพื่อธุรกิจ</span>
                        </button>
                    </li>
                </ul>
            </div>

            <div className="tab-content wrapper-calculate">
                <div className={'tab-pane fade ' + (props.appliedCalcTypes.value.forStay !== null ? 'show active' : '')} id="for-stay" role="tabpanel" aria-labelledby="for-stay-tab" no-decoration={!props.stayCanTakeDecoration.value ? 'true' : 'false'}>
                    <div className="head-table">
                        <div className="column-head-table">
                            <div className="sub-title">ยอดผ่อนชำระต่อเดือน</div>
                            <div className="wrapper-amount">
                                <div className="amount-per-month">{props.stayTotalInstallmentPerMonth.value}</div>
                                <div>บาท</div>
                            </div>
                        </div>
                        <div className="column-head-table">
                            <div className="row-sub-title">
                                <div className="sub-title2">ยอดรวมวงเงินกู้</div>
                                <div className="sub-title2 total">{props.stayTotalLimitAmount.value} <span>บาท</span></div>
                            </div>
                            <div className="row-sub-title has-input">
                                <div className="sub-title2">ระยะเวลาผ่อนชำระ <span>(สูงสุดไม่เกิน {props.stayInstallmentYear.maxValue} ปี)</span></div>
                                <div className="sub-title2"> 
                                    <input id="CalStayInstallmentYear" type="text" className={props.stayInstallmentYear.errorMessage ? 'input-error' : ''} value={props.stayInstallmentYear.value} maxLength={props.stayInstallmentYear.maxLength} onChange={formsDataChange.bind(this, 'stay', 'stayInstallmentYear')} onBlur={formsBlur.bind(this, 'stay', 'stayInstallmentYear')} />
                                    <span>ปี</span>
                                </div>
                                <ErrorMessage message={props.stayInstallmentYear.errorMessage} />
                                {/* <Note message={props.stayInstallmentYear.note} /> */}
                            </div>
                        </div>
                    </div>

                    <div className="body-table">
                        <div className="col-body col-body-box-1">
                            <div className="row-amount view-data">
                                <div className="title-body">วงเงินทรัพย์</div>
                                <div className="input-body">
                                    <input id="CalStayPropertyLimitAmount" type="text" className={props.stayPropertyLimitAmount.errorMessage ? 'input-error' : ''} value={props.stayPropertyLimitAmount.value} maxLength={props.stayPropertyLimitAmount.maxLength} onChange={formsDataChange.bind(this, 'stay', 'stayPropertyLimitAmount')} onBlur={formsBlur.bind(this, 'stay', 'stayPropertyLimitAmount')} />
                                    <span>บาท</span>
                                </div>
                                <ErrorMessage message={props.stayPropertyLimitAmount.errorMessage} />
                            </div>

                            <div className="row-total view-data pointer-none">
                                <div className="title-body2">ยอดผ่อนต่อเดือน <span>(วงเงินทรัพย์)</span></div>
                                <div className="input-body">
                                    <input type="text" value={props.stayPropertyInstallmentPerMonth.value} readOnly />
                                    <span>บาท</span>
                                </div>
                            </div>

                            <div className="row-amount input-data mt15" style={{ paddingTop: 0 }}>
                                <div className="title-body">รายได้ต่อเดือน</div>
                                <div className="input-body">
                                    <input id="CalStayIncomePerMonth" type="text" className={props.stayIncomePerMonth.errorMessage ? 'input-error' : ''} value={props.stayIncomePerMonth.value} maxLength={props.stayIncomePerMonth.maxLength} onChange={formsDataChange.bind(this, 'stay', 'stayIncomePerMonth')} onBlur={formsBlur.bind(this, 'stay', 'stayIncomePerMonth')} />
                                    <span>บาท</span>
                                </div>
                                <ErrorMessage message={props.stayIncomePerMonth.errorMessage} />
                            </div>
                        </div>

                        <div className="col-body col-body-box-2">
                            <div className={"row-amount view-data decoration-limit-field"}>
                                <div className="title-body">วงเงินตกแต่ง</div>
                                <div className="input-body">
                                    <input id="CalStayDecorationLimitAmount" type="text" className={props.stayDecorationLimitAmount.errorMessage ? 'input-error' : ''} value={props.stayDecorationLimitAmount.value} maxLength={props.stayDecorationLimitAmount.maxLength} onChange={formsDataChange.bind(this, 'stay', 'stayDecorationLimitAmount')} onBlur={formsBlur.bind(this, 'stay', 'stayDecorationLimitAmount')} />
                                    <span>บาท</span>
                                </div>
                                <ErrorMessage message={props.stayDecorationLimitAmount.errorMessage} />
                            </div>

                            <div className="row-total view-data pointer-none decoration-installment-field">
                                <div className="title-body2">ยอดผ่อนต่อเดือน <span>(วงเงินตกแต่ง)</span></div>
                                <div className="input-body">
                                    <input type="text" value={props.stayDecorationInstallmentPerMonth.value} readOnly />
                                    <span>บาท</span>
                                </div>
                            </div>
                            
                            <div className="row-total input-data mt15 debt-burden-field" style={{ paddingTop: 0 }}>
                                <div className="title-body2">ภาระหนี้</div>
                                <div className="input-body">
                                    <input id="CalStayDebtBurdenPerMonth" type="text" className={props.stayDebtBurdenPerMonth.errorMessage ? 'input-error' : ''} value={props.stayDebtBurdenPerMonth.value} maxLength={props.stayDebtBurdenPerMonth.maxLength} onChange={formsDataChange.bind(this, 'stay', 'stayDebtBurdenPerMonth')} onBlur={formsBlur.bind(this, 'stay', 'stayDebtBurdenPerMonth')} />
                                    <span>บาท</span>
                                </div>
                                <ErrorMessage message={props.stayDebtBurdenPerMonth.errorMessage} />
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={'tab-pane fade ' + (props.appliedCalcTypes.value.forStay !== null ? '' : 'show active')} id="for-business" role="tabpanel" aria-labelledby="for-business-tab">
                    <div className="head-table">
                        <div className="column-head-table">
                            <div className="sub-title">ยอดผ่อนชำระต่อเดือน</div>
                            <div className="wrapper-amount">
                                <div className="amount-per-month">{props.businessTotalInstallmentPerMonth.value}</div>
                                <div>บาท</div>
                            </div>
                        </div>
                        <div className="column-head-table">
                            <div className="row-sub-title">
                                <div className="sub-title2">ยอดรวมวงเงินกู้</div>
                                <div className="sub-title2">{props.businessTotalLimitAmount.value} <span>บาท</span></div>
                            </div>
                            <div className="row-sub-title has-input">
                                <div className="sub-title2">ระยะเวลาผ่อนชำระ <span>(สูงสุดไม่เกิน {props.businessInstallmentYear.maxValue} ปี)</span></div>
                                <div className="sub-title2">
                                    <input id="CalBusinessInstallmentYear" type="text" className={props.businessInstallmentYear.errorMessage ? 'input-error' : ''} value={props.businessInstallmentYear.value} maxLength={props.businessInstallmentYear.maxLength} onChange={formsDataChange.bind(this, 'business', 'businessInstallmentYear')} onBlur={formsBlur.bind(this, 'business', 'businessInstallmentYear')} />
                                    <span>ปี</span>
                                </div>
                                <ErrorMessage message={props.businessInstallmentYear.errorMessage} />
                                {/* <Note message={props.businessInstallmentYear.note} /> */}
                            </div>
                        </div>
                    </div>

                    <div className="body-table">
                        <div className="col-body col-body-box-1">
                            <div className="row-amount view-data">
                                <div className="title-body">วงเงินทรัพย์</div>
                                <div className="input-body">
                                    <input id="CalBusinessPropertyLimitAmount" type="text" className={props.businessPropertyLimitAmount.errorMessage ? 'input-error' : ''} value={props.businessPropertyLimitAmount.value} maxLength={props.businessPropertyLimitAmount.maxLength} onChange={formsDataChange.bind(this, 'business', 'businessPropertyLimitAmount')} onBlur={formsBlur.bind(this, 'business', 'businessPropertyLimitAmount')} />
                                    <span>บาท{isEditMode && <span className="required-star c-red">*</span>}</span>
                                </div>
                                <ErrorMessage message={props.businessPropertyLimitAmount.errorMessage} />
                            </div>

                            <div className="row-total view-data pointer-none">
                                <div className="title-body2">ยอดผ่อนต่อเดือน <span>(วงเงินทรัพย์)</span></div>
                                <div className="input-body">
                                    <input type="text" value={props.businessPropertyInstallmentPerMonth.value} readOnly />
                                    <span>บาท</span>
                                </div>
                            </div>

                            <div className="row-amount input-data mt15" style={{ paddingTop: 0 }}>
                                <div className="title-body">กำไรสุทธิต่อเดือน</div>
                                <div className="input-body">
                                    <input id="CalBusinessIncomePerMonth" type="text" className={props.businessIncomePerMonth.errorMessage ? 'input-error' : ''} value={props.businessIncomePerMonth.value} maxLength={props.businessIncomePerMonth.maxLength} onChange={formsDataChange.bind(this, 'business', 'businessIncomePerMonth')} onBlur={formsBlur.bind(this, 'business', 'businessIncomePerMonth')} />
                                    <span>บาท</span>
                                </div>
                                <ErrorMessage message={props.businessIncomePerMonth.errorMessage} />
                            </div>
                        </div>

                        <div className="col-body col-body-box-2">
                            <div className="row-amount view-data decoration-limit-field">
                                <div className="title-body">วงเงินตกแต่ง</div>
                                <div className="input-body">
                                    <input id="CalBusinessDecorationLimitAmount" type="text" className={props.businessDecorationLimitAmount.errorMessage ? 'input-error' : ''} value={props.businessDecorationLimitAmount.value} maxLength={props.businessDecorationLimitAmount.maxLength} onChange={formsDataChange.bind(this, 'business', 'businessDecorationLimitAmount')} onBlur={formsBlur.bind(this, 'business', 'businessDecorationLimitAmount')} />
                                    <span>บาท</span>
                                </div>
                                <ErrorMessage message={props.businessDecorationLimitAmount.errorMessage} />
                            </div>

                            <div className="row-total view-data pointer-none decoration-installment-field">
                                <div className="title-body2">ยอดผ่อนต่อเดือน <span>(วงเงินตกแต่ง)</span></div>
                                <div className="input-body">
                                    <input type="text" value={props.businessDecorationInstallmentPerMonth.value} readOnly />
                                    <span>บาท</span>
                                </div>
                            </div>
                            
                            <div className="row-total input-data mt15 debt-burden-field" style={{ paddingTop: 0 }}>
                                <div className="title-body2">ภาระหนี้</div>
                                <div className="input-body">
                                    <input id="CalBusinessDebtBurdenPerMonth" type="text" className={props.businessDebtBurdenPerMonth.errorMessage ? 'input-error' : ''} value={props.businessDebtBurdenPerMonth.value} maxLength={props.businessDebtBurdenPerMonth.maxLength} onChange={formsDataChange.bind(this, 'business', 'businessDebtBurdenPerMonth')} onBlur={formsBlur.bind(this, 'business', 'businessDebtBurdenPerMonth')} />
                                    <span>บาท</span>
                                </div>
                                <ErrorMessage message={props.businessDebtBurdenPerMonth.errorMessage} />
                            </div>
                        </div>
                    </div>

                    {
                        isEditMode && <div class="text-warning"><i class="ic-npa ic-npa-icon-alert"></i><p>กรุณาระบุ “กำไรสุทธิต่อเดือน” และ “ภาระหนี้” <br class="show-xs" /> (ถ้ามี) ให้เรียบร้อยก่อนระบุ “วงเงินทรัพย์”</p></div>
                        //<div className="text-mark c-red">*กรุณาระบุ <strong>"กำไรสุทธิต่อเดือน"</strong> และ <strong>"ภาระหนี้"</strong> (ถ้ามี) ให้เรียบร้อยก่อน ระบุ <strong>"วงเงินทรัพย์"</strong></div>
                    }
                </div>
            </div>

            <div className="text-mark">ผลการคำนวณดังกล่าวเป็นเพียงการประมาณการเบื้องต้นเท่านั้น การพิจารณาสินเชื่อเป็นไปตามข้อกำหนดและเงื่อนไขของธนาคาร</div>
            
            <div className="calculte-button">
                <button id="calculate" type="button" name="calculate" onClick={handleChangeLimitButtonClick}
                data-kbct="apply_btn" data-kblb="cal-change_loan_limit" data-kbgp="calculate" data-kbid={props.propertyId}>เปลี่ยนวงเงินกู้สินเชื่อ</button>
            </div>
            <div id="calculate-result" className="calculate-result">
                <h3>ผลการคำนวณวงเงินกู้เบื้องต้น</h3>
                <div className="calculate-desk">
                    <div className="calculate-card first">
                        <h4>วงเงินที่ต้องการ (บาท)</h4>
                        <input id="financial-amount-input" type="text" value="12,277,000" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')" />
                        <input id="financial-amount-range" type="range" />
                    </div>
                    <div className="calculate-card second">
                        <h4>ระยะเวลากู้ที่ต้องการ (ปี)</h4>
                        <input id="year-input" type="text" value="30" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')" />
                        <input id="year-range" type="range" />
                    </div>
                </div>
                <div className="calculate-card third">
                    <div className="top">
                        <p>วงเงินกู้สูงสุด (บาท)</p>
                        <h5>2,268,000</h5>
                    </div>
                    <div className="bottom">
                        <p>ยอดผ่อนต่อเดือน (บาท)</p>
                        <h5>12,000</h5>
                    </div>
                </div>
                <p className="notice">ผลการคำนวณดังกล่าวเป็นเพียงการประมาณการเบื้องต้นเท่านั้น การพิจารณาสินเชื่อเป็นไปตามข้อกำหนดและเงื่อนไขของธนาคาร</p>
            </div>
        </div>
    </section>
  );
}

function calHomeLoan(options) {
    var careers = ['employee', 'business_owner'];
    var homeLoanTypes = [
        'home1',
        'home2_with_home1_lessthan_2years',
        'home2_with_home1_2years_or_more',
        'home3_or_else'
    ];

    if (careers.indexOf(options.B6_career) === -1) {
        throw new Error('Param B6_career is invalid');
    }

    if (homeLoanTypes.indexOf(options.B3_homeLoanType) === -1) {
        throw new Error('Param B3_homeLoanType is invalid');
    }

    try {
        var errors = [];

        var ROUNDUP = formulajs.ROUNDUP;
        var ROUNDDOWN = formulajs.ROUNDDOWN;
        var PV = formulajs.PV;
        var PMT = formulajs.PMT;

        var B2_propertyPrice = options.B2_propertyPrice;
        var B3_homeLoanType = options.B3_homeLoanType;
        var B5_propertyLoanAmount = options.B5_propertyLoanAmount;
        var B6_career = options.B6_career;
        var B7_age = options.B7_age;
        var B9_propertyLoanYear = options.B9_propertyLoanYear;
        var B10_salary = options.B10_salary;
        var B11_deptBurdenPerMonth = options.B11_deptBurdenPerMonth;
        var B12_appraisalPrice = options.B12_appraisalPrice;
        var B20_decorationLoanAmount = options.B20_decorationLoanAmount;
        var B21_decorationLoanYear = options.B21_decorationLoanYear;
        var calHomeLoanSetting = options.calHomeLoanSetting;
        var F5_limitKBank = calHomeLoanSetting.LimitKBank / 100;
        var F15_MRR = calHomeLoanSetting.KBankMRR / 100;
        var F18_HLBaseRate = +calHomeLoanSetting.HLBaseRate;
        var F24_HDBaseRate = +calHomeLoanSetting.HDBaseRate;

        var F4_limitBot;

        if (B3_homeLoanType === 'home1') {
            if (B2_propertyPrice < 10000000) {
                F4_limitBot = calHomeLoanSetting.LimitBotHouse1LessThan10MB;
            } else {
                F4_limitBot = calHomeLoanSetting.LimitBotHouse1GreaterThan10MB;
            }
        } else if (B3_homeLoanType === 'home2_with_home1_2years_or_more') {
            F4_limitBot = calHomeLoanSetting.LimitBotHouse2InstallGreaterThan2Years;
        } else if (B3_homeLoanType === 'home2_with_home1_lessthan_2years') {
            F4_limitBot = calHomeLoanSetting.LimitBotHouse2InstallLessThan2Years;
        } else if (B3_homeLoanType === 'home3_or_else') {
            F4_limitBot = calHomeLoanSetting.LimitBotHouse3;
        } else {
            F4_limitBot = "";

            errors.push({
                errorCode: 'CalculateF4LimitBotFailed',
                errorMessage: null,
            });
        }

        F4_limitBot = F4_limitBot / 100;

        var F6 = Math.min(F4_limitBot, F5_limitKBank);
        var B4_maxLimitFromPrice;

        if (ROUNDUP((B2_propertyPrice * F6), -3) > B2_propertyPrice) {
            B4_maxLimitFromPrice = B2_propertyPrice;
        } else {
            B4_maxLimitFromPrice = ROUNDUP((B2_propertyPrice * F6), -3);
        }

        var B8_maxLoanYear = Math.min((70 - B7_age), 30);
        var F8_salary;

        if (B10_salary < 30000) {
            F8_salary = calHomeLoanSetting.F8SalaryLessThan30000;
        } else if (B10_salary < 70001) {
            F8_salary = calHomeLoanSetting.F8Salary30000To70000;
        } else if (B10_salary >= 70001) {
            F8_salary = calHomeLoanSetting.F8SalaryGreaterThan70000
        } else {
            F8_salary = "";

            errors.push({
                errorCode: 'CalculateF8SalaryFailed',
                errorMessage: null,
            });
        }

        F8_salary = F8_salary / 100;

        var F9_entre;

        if (B10_salary < 30000) {
            F9_entre = calHomeLoanSetting.F9SalaryLessThan30000;
        } else if (B10_salary < 70001) {
            F9_entre = calHomeLoanSetting.F9Salary30000To70000;
        } else if (B10_salary >= 70001) {
            F9_entre = calHomeLoanSetting.F9SalaryGreaterThan70000
        } else {
            F9_entre = "";

            errors.push({
                errorCode: 'CalculateF9EntreFailed',
                errorMessage: null,
            });
        }

        F9_entre = F9_entre / 100;

        var F10;

        if (B6_career === 'employee') {
            F10 = F8_salary;
        } else if (B6_career === 'business_owner') {
            F10 = F9_entre;
        } else {
            F10 = "";

            errors.push({
                errorCode: 'CalculateF10Failed',
                errorMessage: null,
            });
        }

        var F11_Inst1 = ROUNDUP(B10_salary * F10, -2);
        var F12_Inst2 = F11_Inst1 - B11_deptBurdenPerMonth;
        var F19_HLRate = (F15_MRR - (F18_HLBaseRate / 100)) + 0.01;
        var B15_HLLoanableYear;

        if (F12_Inst2 < 1000) {
            B15_HLLoanableYear = "ไม่ผ่านความสามารถการชำระหนี้";

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else {
            B15_HLLoanableYear = Math.min(B8_maxLoanYear, B9_propertyLoanYear);
        }

        var F13_Limt = ROUNDDOWN(PV(F19_HLRate / 12, B15_HLLoanableYear * 12, -F12_Inst2), -3);
        var B14_HLPrimaryMaxLimit;
        var maxPropertyLimit;

        if (F12_Inst2 < 1000) {
            B14_HLPrimaryMaxLimit = "ไม่ผ่านความสามารถการชำระหนี้";
            maxPropertyLimit = null;

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else {
            B14_HLPrimaryMaxLimit = Math.min(B4_maxLimitFromPrice, B5_propertyLoanAmount, F13_Limt, B12_appraisalPrice);
            maxPropertyLimit = Math.min(B4_maxLimitFromPrice, F13_Limt, B12_appraisalPrice);
        }

        var B16_HLInstallmentPerMonth;

        if (F12_Inst2 < 1000) {
            B16_HLInstallmentPerMonth = "ไม่ผ่านความสามารถการชำระหนี้";

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else {
            B16_HLInstallmentPerMonth = ROUNDUP(PMT(F19_HLRate / 12, B15_HLLoanableYear * 12, -B14_HLPrimaryMaxLimit), -2);
        }

        var F14_LTVMinusHL = Math.min(B12_appraisalPrice - B14_HLPrimaryMaxLimit, B4_maxLimitFromPrice * 0.1);
        var B19_HDMaxDecorationLimit = null;
        var B19_canTakeOnDecorationLoan = true;

        if (B2_propertyPrice >= 10000000) {
            B19_HDMaxDecorationLimit = "ไม่สามารถกู้วงเงินตกแต่ง";
            B19_canTakeOnDecorationLoan = false;

            errors.push({
                errorCode: 'UnableToTakeOnDecorationLoan',
                errorMessage: 'ไม่สามารถกู้วงเงินตกแต่ง',
            });
        } else if (F14_LTVMinusHL >= 1000) {
            B19_HDMaxDecorationLimit = F14_LTVMinusHL;
        } else {
            B19_HDMaxDecorationLimit = "ไม่สามารถกู้วงเงินตกแต่ง";
            B19_canTakeOnDecorationLoan = false;

            errors.push({
                errorCode: 'UnableToTakeOnDecorationLoan',
                errorMessage: 'ไม่สามารถกู้วงเงินตกแต่ง',
            });
        }

        var F28_Inst2MinusB16 = F12_Inst2 - B16_HLInstallmentPerMonth;
        var F25_HDRate = (F15_MRR - (F24_HDBaseRate / 100)) + 0.01;
        var B25_HDLoanableYear;

        if (!B19_canTakeOnDecorationLoan) {
            B25_HDLoanableYear = "ไม่สามารถกู้วงเงินตกแต่ง";

            errors.push({
                errorCode: 'UnableToTakeOnDecorationLoan',
                errorMessage: 'ไม่สามารถกู้วงเงินตกแต่ง',
            });
        } else if (F28_Inst2MinusB16 < 1000) {
            B25_HDLoanableYear = "ไม่ผ่านความสามารถการชำระหนี้";

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else if (B21_decorationLoanYear <= B15_HLLoanableYear) {
            B25_HDLoanableYear = B21_decorationLoanYear;
        } else {
            B25_HDLoanableYear = B15_HLLoanableYear;
        }

        var F29_Limit2 = ROUNDDOWN(PV(F25_HDRate / 12, B25_HDLoanableYear * 12, -F28_Inst2MinusB16), -3);
        var B24_HDPrimaryMaxLimit;
        var maxDecorationLimit;

        if (!B19_canTakeOnDecorationLoan) {
            B24_HDPrimaryMaxLimit = "ไม่สามารถกู้วงเงินตกแต่ง";
            maxDecorationLimit = null;

            errors.push({
                errorCode: 'UnableToTakeOnDecorationLoan',
                errorMessage: 'ไม่สามารถกู้วงเงินตกแต่ง',
            });
        } else if (F28_Inst2MinusB16 < 1000) {
            B24_HDPrimaryMaxLimit = "ไม่ผ่านความสามารถการชำระหนี้";
            maxDecorationLimit = null;

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else {
            if(B20_decorationLoanAmount !== null){
                B24_HDPrimaryMaxLimit = Math.min(B19_HDMaxDecorationLimit, B20_decorationLoanAmount, F29_Limit2);
            } else {
                B24_HDPrimaryMaxLimit = Math.min(B19_HDMaxDecorationLimit, F29_Limit2);
            }

            maxDecorationLimit = Math.min(B19_HDMaxDecorationLimit, F29_Limit2);
        }

        var B26_HDInstallmentPerMonth;

        if (!B19_canTakeOnDecorationLoan) {
            B26_HDInstallmentPerMonth = "ไม่สามารถกู้วงเงินตกแต่ง";

            errors.push({
                errorCode: 'UnableToTakeOnDecorationLoan',
                errorMessage: 'ไม่สามารถกู้วงเงินตกแต่ง',
            });
        } else if (F28_Inst2MinusB16 < 1000) {
            B26_HDInstallmentPerMonth = "ไม่ผ่านความสามารถการชำระหนี้";

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else {
            B26_HDInstallmentPerMonth = ROUNDUP(PMT(F25_HDRate / 12, B25_HDLoanableYear * 12, -B24_HDPrimaryMaxLimit), -2);
        }

        var B28_HLLimit = Math.min(B4_maxLimitFromPrice, B12_appraisalPrice);
        var B29_HLInstallmentPerMonth = ROUNDUP(PMT(F19_HLRate / 12, B8_maxLoanYear * 12, -B28_HLLimit), -2);
        var B33_HDLimit = B2_propertyPrice * 0.1;
        var B34_HDInstallmentPerMonth = ROUNDUP(PMT(F25_HDRate / 12, B8_maxLoanYear * 12, -B33_HDLimit), -2);

        return {
            errors: errors,

            B4_maxLimitFromPrice: B4_maxLimitFromPrice,
            B8_maxLoanYear: B8_maxLoanYear,
            B14_HLPrimaryMaxLimit: B14_HLPrimaryMaxLimit,
            B15_HLLoanableYear: B15_HLLoanableYear,
            B16_HLInstallmentPerMonth: B16_HLInstallmentPerMonth,
            B19_HDMaxDecorationLimit: B19_HDMaxDecorationLimit,
            B19_canTakeOnDecorationLoan: B19_canTakeOnDecorationLoan,
            B24_HDPrimaryMaxLimit: B24_HDPrimaryMaxLimit,
            B25_HDLoanableYear: B25_HDLoanableYear,
            B26_HDInstallmentPerMonth: B26_HDInstallmentPerMonth,
            maxPropertyLimit: maxPropertyLimit,
            maxDecorationLimit: maxDecorationLimit,
            B28_HLLimit: B28_HLLimit,
            B29_HLInstallmentPerMonth: B29_HLInstallmentPerMonth,
            B33_HDLimit: B33_HDLimit,
            B34_HDInstallmentPerMonth: B34_HDInstallmentPerMonth,
            
            inputs: options,
        };
    } catch (e) {
        console.error(e);

        return {
            errors: [
                {
                    errorCode: null,
                    errorMessage: '' + e,
                },
            ],
        };
    }
}

function calLand(options) {
    var careers = ['employee', 'business_owner'];
    var homeLoanTypes = [
        'home1',
        'home2_with_home1_lessthan_2years',
        'home2_with_home1_2years_or_more',
        'home3_or_else'
    ];

    if (careers.indexOf(options.B6_career) === -1) {
        throw new Error('Param B6_career is invalid');
    }

    if (homeLoanTypes.indexOf(options.B3_homeLoanType) === -1) {
        throw new Error('Param B3_homeLoanType is invalid');
    }

    try {
        var errors = [];

        var ROUNDUP = formulajs.ROUNDUP;
        var ROUNDDOWN = formulajs.ROUNDDOWN;
        var PV = formulajs.PV;
        var PMT = formulajs.PMT;

        var B2_propertyPrice = options.B2_propertyPrice;
        var B3_homeLoanType = options.B3_homeLoanType;
        var B5_propertyLoanAmount = options.B5_propertyLoanAmount;
        var B6_career = options.B6_career;
        var B7_age = options.B7_age;
        var B9_propertyLoanYear = options.B9_propertyLoanYear;
        var B10_salary = options.B10_salary;
        var B11_deptBurdenPerMonth = options.B11_deptBurdenPerMonth;
        var B12_appraisalPrice = options.B12_appraisalPrice;
        var calLandSetting = options.calLandSetting;
        var F5_limitKBank = calLandSetting.LimitKBank / 100;
        var F15_MRR = calLandSetting.KBankMRR / 100;
        var F18_baseRate = +calLandSetting.F18BaseRate;

        var F4_limitBot;

        if (B3_homeLoanType === 'home1') {
            if (B2_propertyPrice < 10000000) {
                F4_limitBot = calLandSetting.LimitBotHouse1LessThan10MB;
            } else {
                F4_limitBot = calLandSetting.LimitBotHouse1GreaterThan10MB;
            }
        } else if (B3_homeLoanType === 'home2_with_home1_2years_or_more') {
            F4_limitBot = calLandSetting.LimitBotHouse2InstallGreaterThan2Years;
        } else if (B3_homeLoanType === 'home2_with_home1_lessthan_2years') {
            F4_limitBot = calLandSetting.LimitBotHouse2InstallLessThan2Years;
        } else if (B3_homeLoanType === 'home3_or_else') {
            F4_limitBot = calLandSetting.LimitBotHouse3;
        } else {
            F4_limitBot = "";

            errors.push({
                errorCode: 'CalculateF4LimitBotFailed',
                errorMessage: null,
            });
        }

        F4_limitBot = F4_limitBot / 100;

        var F6 = Math.min(F4_limitBot, F5_limitKBank);
        var B4_maxLimitFromPrice;

        if (ROUNDUP((B2_propertyPrice * F6), -3) > B2_propertyPrice) {
            B4_maxLimitFromPrice = B2_propertyPrice;
        } else {
            B4_maxLimitFromPrice = ROUNDUP((B2_propertyPrice * F6), -3);
        }

        var B8_maxLoanYear = Math.min((70 - B7_age), 10);
        var F8_salary;

        if (B10_salary < 30000) {
            F8_salary = calLandSetting.F8SalaryLessThan30000;
        } else if (B10_salary < 70001) {
            F8_salary = calLandSetting.F8Salary30000To70000;
        } else if (B10_salary >= 70001) {
            F8_salary = calLandSetting.F8SalaryGreaterThan70000
        } else {
            F8_salary = "";

            errors.push({
                errorCode: 'CalculateF8SalaryFailed',
                errorMessage: null,
            });
        }

        F8_salary = F8_salary / 100;

        var F9_entre;

        if (B10_salary < 30000) {
            F9_entre = calLandSetting.F9SalaryLessThan30000;
        } else if (B10_salary < 70001) {
            F9_entre = calLandSetting.F9Salary30000To70000;
        } else if (B10_salary >= 70001) {
            F9_entre = calLandSetting.F9SalaryGreaterThan70000
        } else {
            F9_entre = "";

            errors.push({
                errorCode: 'CalculateF9EntreFailed',
                errorMessage: null,
            });
        }

        F9_entre = F9_entre / 100;

        var F10;

        if (B6_career === 'employee') {
            F10 = F8_salary;
        } else if (B6_career === 'business_owner') {
            F10 = F9_entre;
        } else {
            F10 = "";

            errors.push({
                errorCode: 'CalculateF10Failed',
                errorMessage: null,
            });
        }

        var F11_Inst1 = ROUNDUP(B10_salary * F10, -2);
        var F12_Inst2 = F11_Inst1 - B11_deptBurdenPerMonth;
        var F19_rate = (F15_MRR + (F18_baseRate / 100)) + 0.01;
        var B15_loanableYear;

        if (F12_Inst2 < 1000) {
            B15_loanableYear = "ไม่ผ่านความสามารถการชำระหนี้";

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else {
            B15_loanableYear = Math.min(B8_maxLoanYear, B9_propertyLoanYear);
        }

        var F13_Limt = ROUNDDOWN(PV(F19_rate / 12, B15_loanableYear * 12, -F12_Inst2), -3);
        var B14_primaryMaxLimit;
        var maxPropertyLimit;

        if (F12_Inst2 < 1000) {
            B14_primaryMaxLimit = "ไม่ผ่านความสามารถการชำระหนี้";
            maxPropertyLimit = null;

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else {
            B14_primaryMaxLimit = Math.min(B4_maxLimitFromPrice, B5_propertyLoanAmount, F13_Limt, B12_appraisalPrice);
            maxPropertyLimit = Math.min(B4_maxLimitFromPrice, F13_Limt, B12_appraisalPrice);
        }

        var B16_installmentPerMonth;

        if (F12_Inst2 < 1000) {
            B16_installmentPerMonth = "ไม่ผ่านความสามารถการชำระหนี้";

            errors.push({
                errorCode: 'LackOfPayDeptAbility',
                errorMessage: 'ไม่ผ่านความสามารถการชำระหนี้',
            });
        } else {
            B16_installmentPerMonth = ROUNDUP(PMT(F19_rate / 12, B15_loanableYear * 12, -B14_primaryMaxLimit), -2);
        }

        var B18_HLLimit = Math.min(B4_maxLimitFromPrice, B12_appraisalPrice);
        var B19_HLInstallmentPerMonth = ROUNDUP(PMT(F19_rate / 12, B8_maxLoanYear * 12, -B18_HLLimit), -2);

        return {
            errors: errors,

            B4_maxLimitFromPrice: B4_maxLimitFromPrice,
            B8_maxLoanYear: B8_maxLoanYear,
            B14_primaryMaxLimit: B14_primaryMaxLimit,
            B15_loanableYear: B15_loanableYear,
            B16_installmentPerMonth: B16_installmentPerMonth,
            maxPropertyLimit: maxPropertyLimit,
            B18_HLLimit: B18_HLLimit,
            B19_HLInstallmentPerMonth: B19_HLInstallmentPerMonth,
            
            inputs: options,
        };
    } catch (e) {
        console.error(e);

        return {
            errors: [
                {
                    errorCode: null,
                    errorMessage: '' + e,
                },
            ],
        };
    }
}

function calSME(options) {
    try {
        var ROUND = formulajs.ROUND;
        var ROUNDUP = formulajs.ROUNDUP;

        var D10_propertyPrice = options.D10_propertyPrice;
        var D12_propertyLoanAmount = options.D12_propertyLoanAmount;
        var D18_propertyType = options.D18_propertyType;
        var D20_appraisalPrice = options.D20_appraisalPrice;
        var D28_propertyLoanYear = options.D28_propertyLoanYear;
        var D30_profitPerMonth = options.D30_profitPerMonth;
        var D32_deptBurdenPerMonth = options.D32_deptBurdenPerMonth;
        var D37_decorationLoanAmount = options.D37_decorationLoanAmount;
        var calSMESetting = options.calSMESetting;
        var I25_MRR = calSMESetting.C1_MRR / 100;
        var I26_LNRateForInstallmentSecured = calSMESetting.C2_LNRateForInstallmentSecured / 100;
        var I27_MinimumDSCR = +calSMESetting.C3_MinimumDSCR;
        var I28_NetProfitDeptRatioConfig = +calSMESetting.C4_NetProfitDeptRatioConfig;
        var I32_LTV = calSMESetting.C8_LTV / 100;
        var S15 = 0;

        var I30_maxLoanYear;

        if (D18_propertyType === "other") {
            I30_maxLoanYear = 20;
        } else {
            I30_maxLoanYear = 30;
        }

        var O14_finalTerm = Math.min(I30_maxLoanYear, D28_propertyLoanYear);
        var I17_profitPerMonth;

        if (D32_deptBurdenPerMonth === "" && D30_profitPerMonth === "") {
            I17_profitPerMonth = D12_propertyLoanAmount * ((I25_MRR + I26_LNRateForInstallmentSecured) / 12) / (1 - (Math.pow(1 + ((I25_MRR + I26_LNRateForInstallmentSecured) / 12), -(12 * O14_finalTerm)))) * I27_MinimumDSCR;
        } else {
            I17_profitPerMonth = D30_profitPerMonth;
        }

        var I18_deptBurdenPerMonth = +D32_deptBurdenPerMonth;
        var O17_debtRatio;

        try {
            if (I18_deptBurdenPerMonth === 0) {
                throw new Error('divide by zero');
            }

            if ((I17_profitPerMonth / I18_deptBurdenPerMonth - 1) <= I28_NetProfitDeptRatioConfig) {
                O17_debtRatio = "No";
            } else {
                O17_debtRatio = "Yes";
            }
        } catch (e) {
            O17_debtRatio = 0;
        }

        var I12_loanAmount = D12_propertyLoanAmount;
        var I11_finalPrice;

        if (D20_appraisalPrice < D10_propertyPrice) {
            I11_finalPrice = D20_appraisalPrice;
        } else {
            I11_finalPrice = D10_propertyPrice;
        }

        var O11_interestForIncomingDebt;

        if (I11_finalPrice > 0) {
            O11_interestForIncomingDebt = I25_MRR + I26_LNRateForInstallmentSecured;
        } else {
            O11_interestForIncomingDebt = "";
        }

        var S17_incomingDebt = (I12_loanAmount * (O11_interestForIncomingDebt / 12)) / (1 - (Math.pow(1 + (O11_interestForIncomingDebt / 12), -(O14_finalTerm * 12))));
        var V11_DSCR;

        try {
            if (O17_debtRatio === "No") {
                V11_DSCR = "X";
            } else {
                V11_DSCR = I17_profitPerMonth / (I18_deptBurdenPerMonth + S17_incomingDebt);
            }
        } catch(e) {
            V11_DSCR = 0;
        }

        var V13_maxRepayPerMonthCapability = I17_profitPerMonth / I27_MinimumDSCR;
        var V14_repayPerMonthCapability = V13_maxRepayPerMonthCapability - I18_deptBurdenPerMonth - S15;
        var V17_installmentLimit = V14_repayPerMonthCapability * ((1 / (O11_interestForIncomingDebt / 12)) - (1 / (O11_interestForIncomingDebt / 12 * Math.pow(1 + O11_interestForIncomingDebt / 12, O14_finalTerm * 12))));
        var Z13_limitOnPrice = I11_finalPrice * I32_LTV;
        var Z14_finalOffer;

        try {
            Z14_finalOffer = ROUND(Math.min(V17_installmentLimit, Z13_limitOnPrice, I12_loanAmount), -1);
        } catch (e) {
            Z14_finalOffer = "";
        }

        var AD11_limitDSCRNotPass;

        if (V11_DSCR < 1.2 && Z14_finalOffer > 0 && V11_DSCR !== "X") {
            AD11_limitDSCRNotPass = Z14_finalOffer;
        } else {
            AD11_limitDSCRNotPass = "";
        }

        var Z20_limitOnLorPorGor = I11_finalPrice * I32_LTV;
        var Z21_finalOfferLorPorGor;

        try {
            Z21_finalOfferLorPorGor = ROUND(Math.min(Z20_limitOnLorPorGor, I12_loanAmount, V17_installmentLimit), -1);
        } catch (e) {
            Z21_finalOfferLorPorGor = "";
        }

        var AD12_limitDSCRPass;

        if (V11_DSCR >= 1.2 && Z21_finalOfferLorPorGor > 0 && V11_DSCR !== "X") {
            AD12_limitDSCRPass = Z21_finalOfferLorPorGor;
        } else {
            AD12_limitDSCRPass = "";
        }

        var AE18_primaryMaxLoanAmount;

        if (Math.max(AD11_limitDSCRNotPass, AD12_limitDSCRPass) === 0) {
            AE18_primaryMaxLoanAmount = "";
        } else {
            AE18_primaryMaxLoanAmount = Math.max(AD11_limitDSCRNotPass, AD12_limitDSCRPass);
        }

        var D44_propertyPrimaryMaxLoanAmount = AE18_primaryMaxLoanAmount;
        var D35_maxDecorationLimit;

        if (Math.min(D20_appraisalPrice - D12_propertyLoanAmount, D44_propertyPrimaryMaxLoanAmount * 0.1) <= 0) {
            D35_maxDecorationLimit = 0;
        } else {
            D35_maxDecorationLimit = Math.min(D20_appraisalPrice - D12_propertyLoanAmount, D44_propertyPrimaryMaxLoanAmount * 0.1);
        }

        if (D37_decorationLoanAmount === null) {
            D37_decorationLoanAmount = D35_maxDecorationLimit;
        }

        var D48_decorationPrimaryMaxLoanAmount;

        if (D37_decorationLoanAmount === "") {
            D48_decorationPrimaryMaxLoanAmount = 0;
        } else {
            D48_decorationPrimaryMaxLoanAmount = Math.min(D35_maxDecorationLimit, D37_decorationLoanAmount);
        }

        var Z15_installmentPlusIntOffer = ( Z14_finalOffer * ((I25_MRR + I26_LNRateForInstallmentSecured) / 12)) / (1 - (Math.pow(1 + ((I25_MRR + I26_LNRateForInstallmentSecured) / 12), -(12 * O14_finalTerm))));
        var AE11_installmentDSCRNotPass;

        if (Z15_installmentPlusIntOffer <= 0 || AD11_limitDSCRNotPass === "") {
            AE11_installmentDSCRNotPass = "";
        } else {
            AE11_installmentDSCRNotPass = ROUND(Z15_installmentPlusIntOffer, -1);
        }

        var Z22_installmentPlusIntOffer = (Z21_finalOfferLorPorGor * ((I25_MRR + I26_LNRateForInstallmentSecured) / 12)) / (1 - (Math.pow(1 + ((I25_MRR + I26_LNRateForInstallmentSecured) / 12), -(12 * O14_finalTerm))));        
        var AE12_installmentDSCRPass;

        if (Z22_installmentPlusIntOffer <= 0 || AD12_limitDSCRPass === "") {
            AE12_installmentDSCRPass = "";
        } else {
            AE12_installmentDSCRPass = ROUNDUP(Z22_installmentPlusIntOffer, -2);
        }

        var AE22_installmentPerMonth;

        if (AE18_primaryMaxLoanAmount > 0) {
            //AE22_installmentPerMonth = VLOOKUP(AE18_primaryMaxLoanAmount, AD11_limitDSCRNotPass:AE12_installmentDSCRPass, 2, 0);
            if (AE18_primaryMaxLoanAmount === AD11_limitDSCRNotPass) {
                AE22_installmentPerMonth = AE11_installmentDSCRNotPass;
            } else if (AE18_primaryMaxLoanAmount === AD12_limitDSCRPass) {
                AE22_installmentPerMonth = AE12_installmentDSCRPass;
            } else {
                AE22_installmentPerMonth = "";
            }
        } else {
            AE22_installmentPerMonth = "";
        }

        var D46_propertyInstallmentPerMonth = AE22_installmentPerMonth;
        var D50_decorationInstallmentPerMonth = ROUNDUP((D48_decorationPrimaryMaxLoanAmount / D44_propertyPrimaryMaxLoanAmount) * AE22_installmentPerMonth, -2);
        var AE20_loanableYear;

        if (V11_DSCR === "X" || O14_finalTerm === 0 || O14_finalTerm <= 0) {
            AE20_loanableYear = "";
        } else {
            AE20_loanableYear = O14_finalTerm;
        }

        var D56_loanableYear = AE20_loanableYear;
        var AD47;

        if (V11_DSCR === "X") {
            AD47 = "รายได้ไม่เพียงพอต่อการชำระหนี้";
        } else {
            AD47 = "";
        }

        var D53_errorMessage = AD47;
        var AD48;

        if (V11_DSCR === "X") {
            AD48 = "ท่านสามารถก่อหนี้ได้สูงสุด";
        } else {
            AD48 = "";
        }

        var C54_debtRecommendMessage = AD48;
        var AD49;

        if (V11_DSCR === "X") {
            AD49 = I17_profitPerMonth * 0.8;
        } else {
            AD49 = "";
        }

        var D54_debtRecommendAmount = AD49;

        return {
            errors: [],

            D44_propertyPrimaryMaxLoanAmount: D44_propertyPrimaryMaxLoanAmount,
            D46_propertyInstallmentPerMonth: D46_propertyInstallmentPerMonth,
            D48_decorationPrimaryMaxLoanAmount: D48_decorationPrimaryMaxLoanAmount,
            D50_decorationInstallmentPerMonth: D50_decorationInstallmentPerMonth,
            D56_loanableYear: D56_loanableYear,
            D53_errorMessage: D53_errorMessage,
            C54_debtRecommendMessage: C54_debtRecommendMessage,
            D54_debtRecommendAmount: D54_debtRecommendAmount,
            I30_maxLoanYear: I30_maxLoanYear,

            inputs: options,
        };
    } catch (e) {
        console.error(e);

        return {
            errors: [
                {
                    errorCode: null,
                    errorMessage: '' + e,
                },
            ],
        };
    }
}
